/* CART DRAWER — 30-oct-2026 (v39). Ver el comentario de snippets/cart-drawer.liquid.
   Expone window.XCCart = { open, close, refresh, added } para mp-script (Paquete Mayoreo).
   2-nov-2026 (v41): si el cliente no eligió talla, snippets/guia-tallas.liquid (que escucha
   el submit antes que este archivo) ya cancela el envío y enciende el aviso rojo; aquí se
   respeta e.defaultPrevented y no se manda nada a Shopify (antes respondía "Parameter
   Missing or Invalid" y además salía un alert). Si por lo que sea llega sin talla, se llama
   window.XCFaltaTalla (mp-script) y el alert queda solo de respaldo. */
(function () {
  var cd = document.querySelector('[data-cd]');
  if (!cd || !('fetch' in window)) return;
  var panel = cd.querySelector('.cd__panel');
  var lista = cd.querySelector('[data-cd-lista]');
  var vacio = cd.querySelector('[data-cd-vacio]');
  var pie = cd.querySelector('[data-cd-pie]');
  var nEl = cd.querySelector('[data-cd-n]');
  var aviso = cd.querySelector('[data-cd-aviso]');
  var desc = cd.querySelector('[data-cd-desc]');
  var descN = cd.querySelector('[data-cd-desc-n]');
  var total = cd.querySelector('[data-cd-total]');
  var nota = cd.querySelector('[data-cd-nota]');
  var tpl = document.getElementById('cd-item-tpl');
  var BASE = +cd.dataset.base || 1599;
  var D = { 2: +cd.dataset.d2 || 50, 3: +cd.dataset.d3 || 110, 6: +cd.dataset.d6 || 160, 12: +cd.dataset.d12 || 210, 20: +cd.dataset.d20 || 310 };
  var abierto = false, ultimoFoco = null, timer = null;

  function money(c) {
    var n = c / 100;
    var s = n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return '$ ' + s;
  }
  function esStock(it) {
    var t = (it.product_title || it.title || '').toLowerCase();
    return t.indexOf('(stock)') >= 0 || /\bstock\b/.test(t);
  }
  function contador(n) {
    var a = document.querySelector('.nav__cart');
    if (!a) return;
    var c = a.querySelector('.nav__cart-count');
    if (n > 0) {
      if (!c) { c = document.createElement('span'); c.className = 'nav__cart-count'; a.appendChild(c); }
      c.textContent = n;
    } else if (c) { c.remove(); }
  }

  function render(cart) {
    var n = cart.item_count || 0;
    nEl.textContent = n > 0 ? n : '';
    contador(n);
    lista.innerHTML = '';
    if (!cart.items || !cart.items.length) {
      vacio.hidden = false; pie.hidden = true; aviso.hidden = true; return;
    }
    vacio.hidden = true; pie.hidden = false;
    var hayStock = false;
    cart.items.forEach(function (it) {
      if (esStock(it)) hayStock = true;
      var f = tpl.content.cloneNode(true);
      var art = f.querySelector('.cd__it'); art.dataset.key = it.key;
      var img = f.querySelector('.cd__img img');
      if (it.image) { img.src = it.image + (it.image.indexOf('?') > 0 ? '&' : '?') + 'width=160'; img.alt = it.product_title; } else { img.remove(); }
      f.querySelector('.cd__img').href = it.url;
      var nom = f.querySelector('.cd__nom'); nom.textContent = it.product_title; nom.href = it.url;
      var v = f.querySelector('.cd__var');
      if (it.variant_title && it.variant_title !== 'Default Title') v.textContent = 'Talla ' + it.variant_title + ' MX'; else v.remove();
      f.querySelector('[data-cd-ahora]').textContent = money(it.final_price);
      var antes = f.querySelector('[data-cd-antes]');
      if (it.original_price > it.final_price) { antes.textContent = money(it.original_price); antes.hidden = false; }
      f.querySelector('[data-cd-q]').textContent = it.quantity;
      f.querySelector('[data-cd-linea]').textContent = money(it.final_line_price);
      lista.appendChild(f);
    });
    if (cart.total_discount > 0) { descN.textContent = '−' + money(cart.total_discount); desc.hidden = false; } else { desc.hidden = true; }
    total.textContent = money(cart.total_price);
    /* aviso de mayoreo: la misma escalera que sections/main-cart.liquid */
    var txt = '';
    if (!hayStock) {
      if (n === 1) txt = 'Agrega 1 par más y cada par te sale en <b>' + money((BASE - D[2]) * 100) + '</b>.';
      else if (n === 2) txt = 'Agrega 1 par más y el precio baja a <b>' + money((BASE - D[3]) * 100) + ' por par</b>.';
      else if (n < 6) txt = 'Llega a 6 pares y cada par te sale en <b>' + money((BASE - D[6]) * 100) + '</b>.';
      else if (n < 12) txt = 'Llega a 12 pares y cada par te sale en <b>' + money((BASE - D[12]) * 100) + '</b>.';
      else if (n < 20) txt = 'Llega a 20 pares y cada par te sale en <b>' + money((BASE - D[20]) * 100) + '</b>.';
    }
    aviso.innerHTML = txt; aviso.hidden = !txt;
    nota.innerHTML = hayStock
      ? '<b>Tu par de stock sale desde Guadalajara:</b> entrega personal gratis en GDL, repartidor en la zona metropolitana ($80) o paquetería a todo México ($220, 1 a 4 días hábiles). Eliges al pagar. Si quieres entrega personal, deja tu Instagram en <a href="/cart">el carrito completo</a>.'
      : '<b>Envío gratis a todo México.</b> Los descuentos por cantidad se aplican solos al finalizar la compra.';
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; });
  }
  function open() {
    if (abierto) return;
    abierto = true; ultimoFoco = document.activeElement;
    clearTimeout(timer);
    cd.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { cd.classList.add('cd--on'); }); });
    cd.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sin-scroll');
    setTimeout(function () { panel.focus(); }, 60);
  }
  function close() {
    if (!abierto) return;
    abierto = false;
    cd.classList.remove('cd--on');
    cd.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sin-scroll');
    timer = setTimeout(function () { cd.hidden = true; }, 380);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }
  function added() { return refresh().then(open); }
  function cambia(key, q) {
    cd.classList.add('cd--cargando');
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { refresh(); })
      .then(function () { cd.classList.remove('cd--cargando'); });
  }

  cd.querySelectorAll('[data-cd-cerrar]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierto) close(); });
  lista.addEventListener('click', function (e) {
    var art = e.target.closest('.cd__it'); if (!art) return;
    var q = parseInt(art.querySelector('[data-cd-q]').textContent, 10) || 1;
    if (e.target.closest('[data-cd-mas]')) cambia(art.dataset.key, q + 1);
    else if (e.target.closest('[data-cd-menos]')) cambia(art.dataset.key, Math.max(0, q - 1));
    else if (e.target.closest('[data-cd-quitar]')) cambia(art.dataset.key, 0);
  });

  /* icono del carrito: abre el panel en vez de ir a /cart (salvo en /cart mismo) */
  var icono = document.querySelector('.nav__cart');
  if (icono && location.pathname !== '/cart') {
    icono.addEventListener('click', function (e) { e.preventDefault(); refresh().then(open); });
  }

  /* formulario de producto: agrega por AJAX y abre el panel. El Paquete Mayoreo
     lo maneja snippets/mp-script.liquid y luego llama a XCCart.added(). */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (e.defaultPrevented) return; /* guia-tallas ya lo detuvo: falta la talla */
    var sel = document.getElementById('cant-selector');
    if (sel) { var r = sel.querySelector('input[name="cant"]:checked'); if (r && r.value === 'pack') return; }
    e.preventDefault();
    var fd = new FormData(form); fd.delete('cant');
    if (!fd.get('id')) {
      if (window.XCFaltaTalla) { window.XCFaltaTalla(); return; }
      var tallas = form.querySelector('.tallas');
      if (tallas) tallas.scrollIntoView({ block: 'center', behavior: 'smooth' });
      alert('Elige tu talla antes de continuar.');
      return;
    }
    var btn = form.querySelector('[type="submit"]');
    var txt = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return added(); })
      .catch(function () { alert('No se pudo agregar al carrito. Intenta de nuevo.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = txt; } });
  }, true);

  window.XCCart = { open: function () { return refresh().then(open); }, close: close, refresh: refresh, added: added };
})();